import React from 'react'
import styled from 'styled-components'
import Container from '../system/container/container'
import GeneralIcon from './general.svg'
import RentalIcon from './rental.svg'
import TicketingIcon from './ticketing.svg'
import { fonts, colors } from '../../styles/theme'
import Link from 'next/link'

const StyledContainer = styled(Container)`
  text-align: center;
  margin-top: ${props => props.theme.spacing.base700};
  margin-bottom: ${props => props.theme.spacing.base700};
`

const H2 = styled.h2`
  grid-area: h2;
`

const Categories = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  place-items: center;

  margin-top: ${props => props.theme.spacing.base700};
`

const Category = styled.div`
  display: block;
  border-radius: 3px;
  padding: ${props => props.theme.spacing.base500};
  cursor: pointer;

  &:hover {
    background-color: ${colors.neutral300};
  }

  h5 {
    font-family: ${fonts.raleway};
    margin: 0;
  }

  p {
    margin: 0 auto;
    width: 85%;
  }
`

const ContactCategory = () => (
  <StyledContainer>
    <H2>How can we help?</H2>
    <Categories>
      <Link href="/contact/general" className="unstyled">

        <Category>
          <GeneralIcon />
          <h5>General</h5>
          <p>I have a general inquiry regarding the Performing Arts Center</p>
        </Category>

      </Link>
      <Link href="/contact/ticketing" className="unstyled">

        <Category>
          <TicketingIcon />
          <h5>Ticketing</h5>
          <p>I have a question about ticketing for an upcoming event</p>
        </Category>

      </Link>
      <Link href="/contact/rental" className="unstyled">

        <Category>
          <RentalIcon />
          <h5>Rental</h5>
          <p>I’d like to inquire about renting the venue for my event</p>
        </Category>

      </Link>
    </Categories>
  </StyledContainer>
)

export default ContactCategory
